module.exports = __webpack_public_path__ + "static/media/directions-solid.81d5912a.svg";